import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ConfirmRegistration from "./pages/comfirmRegistration/ConfirmRegistration";
import Registration from "./pages/registration/Registration";
import "./App.css";
import AdminLoginPage from "./pages/admin-login/AdminLoginPage";
import AdminDashboardPage from "./pages/admin-dashboard-page/AdminDashboardPage";
import { PrivateRoute } from "./pages/private-route/PrivateRoute";
import { PasswordRestPage } from "./pages/password-reset/PasswordRestPage";
import { Ambassador } from "./pages/ambassador/Ambassador";
import AmbassadorLanding from "./pages/ambassador/AmbassadorLanding";
import Enrollment from "./pages/enrolment/Enrolment";
import EnrolmentDetails from "./pages/enrolmentDetails/enrolmentDetails";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Staffs } from "./pages/staffs/Staffs";
import Leads from "./pages/lead/Lead";
import LeadLanding from "./pages/lead/LeadLanding";
import Student from "./pages/student/Student";
import StudentLanding from "./pages/student/StudentLanding";
import PreEnrolment from "./pages/pre-enrolment/PreEnrolment";
import PreEnrolmentDetails from "./pages/preEnrolmentDetails/preEnrolmentDetails";
import { Blogs } from "./pages/blogs/Blogs";
import CreateBlog from "./components/blog/CreateBlog";
import SingleBlog from "./components/blog/SingleBlog";
import EditBlog from "./components/blog/EditBlog";
import Course from "./pages/course/Course";
import Reviews from "./pages/reviews/Reviews";
import Settings from "./pages/settings/Settings";
import Testimonials from "./pages/testimonials/Testimonials";
import Events from "./pages/events/Events";
import Careers from "./pages/careers/Careers";
import FreeResources from "./pages/free-resources/FreeResources";
import AddFreeResource from "./pages/free-resources/AddFreeResource";
import EditFreeResource from "./pages/free-resources/EditFreeResource";

const App = () => {
  return (
    <div>
      <ToastContainer />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<AdminLoginPage />} />
          <Route path="/reset-password" element={<PasswordRestPage />} />
          <Route path="/email-verification" element={<ConfirmRegistration />} />
          <Route path="*" element={<h1>404 page not found</h1>} />

          {/* Protected routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/settings" element={<Settings />} />
            <Route path="/dashboard" element={<AdminDashboardPage />} />
            <Route path="/staffs" element={<Staffs />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/blog/create" element={<CreateBlog />} />
            <Route path="/blog/:slug" element={<SingleBlog />} />
            <Route path="/blog/edit/:slug" element={<EditBlog />} />
            <Route path="/course" element={<Course />} />
            <Route path="/course/:add?" element={<Course />} />
            <Route path="/ambassadors" element={<Ambassador />} />
            <Route path="/ambassador/:_id" element={<AmbassadorLanding />} />
            <Route path="/staff/registration" element={<Registration />} />
            <Route path="/lead/:_id" element={<LeadLanding />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/student" element={<Student />} />
            <Route path="/testimonial" element={<Testimonials />} />
            <Route path="/events" element={<Events />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/free-resources" element={<FreeResources />} />
            <Route path="/free-resources/create" element={<AddFreeResource />} />
            <Route path="/free-resources/edit/:id" element={<EditFreeResource />} />
            <Route path="/studentInfo/:_id" element={<StudentLanding />} />
            <Route path="/enrolInfo/:_id" element={<EnrolmentDetails />} />
            <Route path="/enrollment/:_id" element={<Enrollment />} />
            <Route path="/enrol/:add?" element={<Enrollment />} />
            <Route
              path="/pre-enrolInfo/:_id"
              element={<PreEnrolmentDetails />}
            />
            <Route path="/pre-enrolment" element={<PreEnrolment />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default App;
